import StylePanelContainer from './StylePanelContainer';

export default StylePanelContainer;